import React, { CSSProperties, ReactNode, useEffect, useState } from "react"
import {InputIconContainer, InputStringError} from "../../components/ui/InputSearch";
import {Clear, Eye, EyeFixed} from "../../icon/Icon";
import {EyeCircle, FormLabel, Input, InputContainer} from "../../components/ui/Content";
import {EyeWatch} from "../../utils/eyeWatch";
import styled from "styled-components/macro";
import NumberFormat from "react-number-format";
import {useTheme} from "styled-components";
import {Caption2} from "../../components/Font";

export enum InputTypeEnum {
    Text = 'text',
    Password = 'password',
    Email = 'email'
}

export enum InputAutoCompleteEnum {
    NewPassword = 'new-password',
    CurrentPassword = 'current-password'
}

type InteractionEvent =
  | React.MouseEvent<HTMLElement>
  | React.TouchEvent<HTMLElement>;


export interface InputSearchProps {
    value: string
    onChange: (value: string) => void
    minLength?: number
    maxLength?: number
    required?: boolean
    placeholder?: string
    type?: InputTypeEnum
    error?: string

    onKeyDown?(keyCode: string): void

    format?: string
    mask?: string
    className?: string
    width?: string
    autofocus?: boolean
    title?: string
    disabled?:boolean
    autoComplete?: string
    regex?: RegExp
    style?: CSSProperties
    icon?: ReactNode
    noClear?: boolean
}

export const InputElement = ({
                                 value,
                                 onChange,
                                 minLength,
                                 maxLength,
                                 required,
                                 placeholder,
                                 type,
                                 onKeyDown,
                                 error,
                                 mask,
                                 format,
                                 className,
                                 width,
                                 autofocus,
                                 title,
                                 disabled = false,
                                 autoComplete,
                                 regex,
                                 style,
                                 icon,
                                 noClear,
                             }: InputSearchProps): React.ReactElement => {

    const [passwordHidden, setPasswordHidden] = useState(true)
    const [eyeMove, setEyeMove] = useState(false)
    const [focused, setFocused] = useState(false)

    const Theme = useTheme()

    useEffect(() => {
        if (eyeMove) {
            document.addEventListener('mousemove', (e) => EyeWatch(e))
        } else {
            document.removeEventListener('mousemove', (e) => EyeWatch(e))
        }
    }, [eyeMove])

    // Функция клика на InputContainer, для корректной работы полей ввода на Android
    const handleContainerClick = (e: InteractionEvent) => {
      const input = e.currentTarget.querySelector("input");

      if (input && document.activeElement !== input) {
        input.focus();
        setTimeout(() => input.focus(), 100);
      }
    };

    return <><InputContainer
        onClick={handleContainerClick}
        style={style}
        className={'input-container'}
        border_color={
            focused
                ? '#007AFF'
                : error
                    ? Theme.color.danger
                    : 'rgba(0, 0, 0, 0.12)'}>
        {title && <Caption2 style={{marginBottom: '8px'}} color={Theme.color.secondary}>{title}</Caption2>}
        {mask && format
            ? <NumberFormat
                placeholder=" "
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                autoFocus={autofocus}
                style={{width: width ? width : '100%'}}
                className={`input-${placeholder} ${className}`}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => onKeyDown && onKeyDown(e.key)}
                required={required || false}
                format={format}
                mask={mask}
                value={value}
                onValueChange={(e) => {
                    onChange(e.value)
                }}/>
            : <Input
                placeholder=" "
                autoFocus={autofocus}
                className={`input-${placeholder} ${className}`}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => onKeyDown && onKeyDown(e.key)}
                minLength={minLength || 0}
                maxLength={maxLength || 999}
                style={{
                    width: width ? width : type === InputTypeEnum.Password
                        ? '75%' : '100%'
                }}
                required={required || false}
                type={type === InputTypeEnum.Password
                    ?
                    passwordHidden
                        ? InputTypeEnum.Password
                        : InputTypeEnum.Text
                    : type}
                onFocus={() => {
                    setFocused(true)
                    setEyeMove(true)
                }}
                onBlur={() => {
                    setFocused(false)
                    setEyeMove(false)
                }}
                autoComplete={autoComplete || undefined}
                value={value}
                onChange={(e) => {
                    if (regex) {
                        if (regex.test(e.target.value)) {
                            onChange(e.target.value)
                        }
                        return
                    }
                    onChange(e.target.value)
                }}
                disabled={disabled}
                />}
        <FormLabel
            htmlFor="name">
            {placeholder}
        </FormLabel>
        {value !== '' && <InputIconContainer
            style={{
                right: type === InputTypeEnum.Password
                    ? '45px' : '15px', top: ''
            }}

            onClick={() => {
                if (noClear) return
                onChange('')
            }}>
            {!noClear && <Clear/>}
            {icon}
        </InputIconContainer>}
        <EyeContainer
            className={`${type === InputTypeEnum.Password ? 'visible' : 'invisible'}`}
            onClick={() => {
                setPasswordHidden(!passwordHidden)
            }}>
            {eyeMove
                ? <>
                    <Eye/>
                    <EyeCircle className={'eye-opened'}/>
                </>
                : <EyeFixed opened={!passwordHidden}/>}
        </EyeContainer>
    </InputContainer>
        <InputStringError error={error} className="error">
            {error}
        </InputStringError></>
}

const EyeContainer = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  right: 16px;
  top: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`
